<template>
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8644 14.3263C12.8644 15.1336 12.2535 15.7881 11.5 15.7881C10.7465 15.7881 10.1356 15.1336 10.1356 14.3263C10.1356 13.5189 10.7465 12.8644 11.5 12.8644C12.2535 12.8644 12.8644 13.5189 12.8644 14.3263Z"
      style="stroke: none !important"
    />
    <path
      d="M6.72458 15.7881C7.53194 15.7881 8.18644 15.1336 8.18644 14.3263C8.18644 13.5189 7.53194 12.8644 6.72458 12.8644C5.91721 12.8644 5.26271 13.5189 5.26271 14.3263C5.26271 15.1336 5.91721 15.7881 6.72458 15.7881Z"
      style="stroke: none !important"
    />
    <path
      d="M17.7373 14.3263C17.7373 15.1336 17.0828 15.7881 16.2754 15.7881C15.4681 15.7881 14.8136 15.1336 14.8136 14.3263C14.8136 13.5189 15.4681 12.8644 16.2754 12.8644C17.0828 12.8644 17.7373 13.5189 17.7373 14.3263Z"
      style="stroke: none !important"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.25 1.91667H18.2083C19.4787 1.91819 20.6966 2.42351 21.5949 3.32179C22.4932 4.22008 22.9985 5.43797 23 6.70833V18.2083C22.9985 19.4787 22.4932 20.6966 21.5949 21.5949C20.6966 22.4932 19.4787 22.9985 18.2083 23H4.79167C3.5213 22.9985 2.30341 22.4932 1.40513 21.5949C0.506845 20.6966 0.0015217 19.4787 0 18.2083V6.70833C0.0015217 5.43797 0.506845 4.22008 1.40513 3.32179C2.30341 2.42351 3.5213 1.91819 4.79167 1.91667H5.75V0.958333C5.75 0.704168 5.85097 0.460412 6.03069 0.280689C6.21041 0.100967 6.45417 0 6.70833 0C6.9625 0 7.20625 0.100967 7.38598 0.280689C7.5657 0.460412 7.66667 0.704168 7.66667 0.958333V1.91667H15.3333V0.958333C15.3333 0.704168 15.4343 0.460412 15.614 0.280689C15.7937 0.100967 16.0375 0 16.2917 0C16.5458 0 16.7896 0.100967 16.9693 0.280689C17.149 0.460412 17.25 0.704168 17.25 0.958333V1.91667ZM2.75873 4.6754C2.21957 5.21457 1.91667 5.94584 1.91667 6.70833V7.66667H21.0833V6.70833C21.0833 5.94584 20.7804 5.21457 20.2413 4.6754C19.7021 4.13623 18.9708 3.83333 18.2083 3.83333H4.79167C4.02917 3.83333 3.2979 4.13623 2.75873 4.6754ZM4.79167 21.0833H18.2083C18.9708 21.0833 19.7021 20.7804 20.2413 20.2413C20.7804 19.7021 21.0833 18.9708 21.0833 18.2083V9.58333H1.91667V18.2083C1.91667 18.9708 2.21957 19.7021 2.75873 20.2413C3.2979 20.7804 4.02917 21.0833 4.79167 21.0833Z"
      style="stroke: none !important"
    />
  </svg>
</template>
